var map = {
	"./close": "Mz/H",
	"./close.js": "Mz/H",
	"./email": "VAci",
	"./email.js": "VAci",
	"./github": "yfZV",
	"./github.js": "yfZV",
	"./instagram": "+lXv",
	"./instagram.js": "+lXv",
	"./linkedin": "esZA",
	"./linkedin.js": "esZA",
	"./svg/Icon-email@1.5x.svg": "uzov",
	"./svg/Icon-github-mark@1.5x.svg": "FRE2",
	"./svg/Icon-linkedin-mark@1.5x.svg": "m5Yp",
	"./svg/Icon-twitter-mark@1.5x.svg": "2fGI",
	"./svg/service-branding.svg": "yKzm",
	"./svg/service-datavis.svg": "aSAa",
	"./svg/service-editorial.svg": "4rwO",
	"./twitter": "d6Sx",
	"./twitter.js": "d6Sx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JNzW";